import { ref } from 'vue'
import { acceptHMRUpdate, defineStore } from 'pinia'

export type HTTPStoreState = {
  cache: {[key: string]: unknown},
  setCache: (cacheKey: string, value: unknown) => void,
  clearCache: (cacheKey: string) => void
}

export const useHttpStore = defineStore('http', () => {
  const cache = ref<HTTPStoreState['cache']>({})

  function setCache(cacheKey: string, response: unknown) {
    cache.value[cacheKey] = Object.freeze(response)
  }

  function clearCache(cacheKey: string): void {
    if (cacheKey in cache.value) {
      Vue.delete(cache.value, cacheKey)
    }
  }

  return {
    cache,
    setCache,
    clearCache,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useHttpStore, import.meta.hot))
}